import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {parseApplicationUidFromType} from '../../../../../helpers/models/topicHelpers';
import {AppState} from '../../../../../store/appState';
import {getFlatApplications} from '../../../../../store/data/applications/applicationsSelectors';
import {getConversations, getTopics} from '../../../../../store/data/dataSelectors';
import {getUser} from '../../../../../store/data/teammates/teammatesSelectors';
import {ActivityReferencePreviewerPill} from './activityReferencePreviewerPill';

/*
 * Props.
 */

interface ActivityReferencePreviewerPillContainerProps {
  topicId: number;
  conversationId: number;
}

/*
 * Selectors.
 */

function getTopicId(_state: AppState, props: ActivityReferencePreviewerPillContainerProps) {
  return props.topicId;
}

function getConversationId(_state: AppState, props: ActivityReferencePreviewerPillContainerProps) {
  return props.conversationId;
}

const getTopic = createSelector([getTopicId, getTopics], (topicId, topics) => topics[topicId]);

const getApplication = createSelector([getTopic, getFlatApplications], (topic, applications) => {
  if (!topic) {
    return undefined;
  }
  const applicationUid = parseApplicationUidFromType(topic);
  return applications.find((application) => application.uid === applicationUid);
});

const getConversation = createSelector(
  [getConversationId, getConversations],
  (conversationId, conversations) => conversations[conversationId],
);

const getTeammateId = createSelector([getUser], (user) => user.id);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ActivityReferencePreviewerPillContainerProps>()(() => ({
  topic: getTopic,
  application: getApplication,
  conversation: getConversation,
  teammateId: getTeammateId,
}));

export const ActivityReferencePreviewerPillContainer = connect(mapStateToProps)(
  ActivityReferencePreviewerPill,
);
